import React from 'react'
import About from './About'

export default function AboutPage() {
  return (
      <div>
          <About/>
    </div>
  )
}
